var youbora = require('youboralib')
var manifest = require('../manifest.json')

youbora.adapters.Flowplayer = youbora.Adapter.extend({

  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.video.time
  },

  /** Override to return current playrate */
  getPlayrate: function () {
    if (this.flags.isPaused) return 0
    return this.player.currentSpeed
  },

  getIsLive: function () {
    return this.player.conf.live
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.player.video.duration
  },

  /** Override to return rendition */
  getRendition: function () {
    if (this.player.video.qualities && typeof this.player.video.quality != "undefined") {
      for (index in this.player.video.qualities) {
        if (this.player.video.quality === this.player.video.qualities[index].value)
          return this.player.video.qualities[index].label
      }
    }
    return null
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.player.video.src || this._resource
  },

  /** Override to return player version */
  getPlayerVersion: function () {
    return flowplayer.version
  },

  /** Override to return player's name */
  getPlayerName: function () {
    return "Flowplayer"
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    // Console all events if logLevel=DEBUG
    youbora.Util.logAllEvents(this.player)

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, true)

    // References
    this.references = []
    this.references['load'] = this.loadListener.bind(this)
    this.references['progress'] = this.timeupdateListener.bind(this)
    this.references['pause'] = this.pauseListener.bind(this)
    this.references['resume'] = this.resumeListener.bind(this)
    this.references['error'] = this.errorListener.bind(this)
    this.references['beforeseek'] = this.seekingListener.bind(this)
    this.references['finish'] = this.endedListener.bind(this)
    this.references['stop'] = this.endedListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.on(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    this.monitor.stop()

    // unregister listeners
    if (this.player && this.references) {
      for (var key in this.references) {
        this.player.off(key, this.references[key])
      }
      this.references = []
    }
  },

  /** Listener for 'load' event. */
  loadListener: function (ev, obj, vid) {
    this._resource = vid.src
    this.fireStart()
    this.firstProgressSent = false
  },

  /** Listener for 'progress' event. */
  timeupdateListener: function (ev, obj, playhead) {
    if (playhead > 0.1) {
      if (!this.crashed) {
        this.fireStart()
      }
      if (this.firstProgressSent) this.fireJoin()
      this.firstProgressSent = true
    }
    if (this.flags.isSeeking && !this.player.paused) {
      this.fireSeekEnd()
      this.monitor.skipNextTick()
    }
  },

  /** Listener for 'pause' event. */
  pauseListener: function (e) {
    if (this.getPlayhead() >= this.getDuration()) {
      this.fireStop()
    } else {
      this.firePause()
    }
  },

  /** Listener for 'playing' event. */
  resumeListener: function (e) {
    this.fireStart()
    this.fireResume()
    this.firstProgressSent = false
  },

  /** Listener for 'error' event. */
  errorListener: function (ev, obj, error) {
    this.fireError(error.code, error.message)
    this.crashed = true
    this.fireStop()
  },

  /** Listener for 'beforeseek' event. */
  seekingListener: function (e) {
    this.fireSeekBegin()
  },

  /** Listener for 'stop' and 'finish' events. */
  endedListener: function (e) {
    this.fireStop()
  }
})

module.exports = youbora.adapters.Flowplayer
